import React from 'react';
import PropTypes from 'prop-types';
import Box from '@material-ui/core/Box';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Avatar, { ICON_COLOR } from '@scoir/avatar';
import Button from '@material-ui/core/Button';

var CoreEmptyState = function CoreEmptyState(_ref) {
  var title = _ref.title,
      subTitle = _ref.subTitle,
      icon = _ref.icon,
      children = _ref.children,
      condensed = _ref.condensed;
  var avatarSize = condensed ? undefined : 'lg';
  return /*#__PURE__*/React.createElement(Paper, {
    elevation: 0
  }, /*#__PURE__*/React.createElement(Box, {
    p: condensed ? 2 : 5,
    display: "flex",
    alignItems: "center",
    flexDirection: "column"
  }, /*#__PURE__*/React.createElement(Box, {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column"
  }, /*#__PURE__*/React.createElement(Box, {
    mb: condensed ? 0 : 2
  }, /*#__PURE__*/React.createElement(Avatar, {
    size: avatarSize,
    variant: "circular",
    iconColor: ICON_COLOR["default"],
    fallbackIcon: /*#__PURE__*/React.createElement(FontAwesomeIcon, {
      icon: icon,
      size: avatarSize
    })
  })), /*#__PURE__*/React.createElement(Box, {
    pt: 2,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column"
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: condensed ? 'body1' : 'h6',
    color: "textPrimary"
  }, title), /*#__PURE__*/React.createElement(Box, {
    pt: condensed ? 0 : 1
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "body2",
    color: "textSecondary",
    align: "center"
  }, subTitle))), children && /*#__PURE__*/React.createElement(Box, {
    pt: condensed ? 1 : 3
  }, children))));
};

CoreEmptyState.propTypes = {
  title: PropTypes.node.isRequired,
  subTitle: PropTypes.node,
  icon: PropTypes.any,
  children: PropTypes.any,
  condensed: PropTypes.bool
};

var BasicEmptyState = function BasicEmptyState(_ref) {
  var title = _ref.title,
      subTitle = _ref.subTitle,
      icon = _ref.icon,
      condensed = _ref.condensed;
  return /*#__PURE__*/React.createElement(CoreEmptyState, {
    title: title,
    subTitle: subTitle,
    icon: icon,
    condensed: condensed
  });
};

BasicEmptyState.propTypes = {
  title: PropTypes.node.isRequired,
  subTitle: PropTypes.node,
  icon: PropTypes.any.isRequired,
  condensed: PropTypes.bool
};

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

var ActionButton = function ActionButton(props) {
  return /*#__PURE__*/React.createElement(Button, _extends({
    variant: "contained",
    color: "primary",
    size: "large"
  }, props));
};

var EmptyStateWithAction = function EmptyStateWithAction(_ref) {
  var title = _ref.title,
      subTitle = _ref.subTitle,
      icon = _ref.icon,
      actionProps = _ref.actionProps,
      condensed = _ref.condensed;
  return /*#__PURE__*/React.createElement(CoreEmptyState, {
    title: title,
    subTitle: subTitle,
    icon: icon,
    condensed: condensed
  }, /*#__PURE__*/React.createElement(ActionButton, actionProps));
};

EmptyStateWithAction.propTypes = {
  title: PropTypes.node.isRequired,
  subTitle: PropTypes.node.isRequired,
  icon: PropTypes.any.isRequired,
  actionProps: PropTypes.object.isRequired,
  condensed: PropTypes.bool
};

export { BasicEmptyState, CoreEmptyState, EmptyStateWithAction };
//# sourceMappingURL=index.module.js.map
